<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../../../component/common/Loading/LoadingContentView.svelte";
    import BackLinkView from "../../../../component/common/Link/BackLinkView.svelte";
    import LabelValueView from "../../../../component/common/Value/LabelValueView.svelte";
    import {BinaryUtil} from "../../../../lib/BinaryUtil";
    import BinaryTagAreaView from "./Tag/BinaryTagAreaView.svelte";
    import BinaryDescriptionView from "./Parts/BinaryDescriptionView.svelte";
    import BinaryTagAddDialogView from "./Tag/BinaryTagAddDialogView.svelte";
    import BinaryQrCodeView from "./Parts/BinaryQrCodeView.svelte";
    import FontAwesomeView from "../../../../component/common/Image/FontAwesomeView.svelte";
    import PlatformTypeIconView from "../../../../component/Binary/PlatformTypeIconView.svelte";
    import BinaryLinkCopyButtonView from "./Parts/BinaryLinkCopyButtonView.svelte";
    import BinaryDownloadView from "../../../../component/Binary/BinaryDownloadView.svelte";
    import BinaryStatusAreaView from "../../../../component/Binary/BinaryStatusAreaView.svelte";
    import BinaryCiJobLinkView from "./Parts/BinaryCiJobLinkView.svelte";
    import HtmlTitleView from "../../../../component/common/Html/HtmlTitleView.svelte";
    import BinaryEditDialogView from "./BinaryEditDialogView.svelte";
    import EditButtonView from "../../../../component/common/Button/EditButtonView.svelte";
    import CreatedUpdatedView from "../../../../component/common/Value/CreatedUpdatedView.svelte";
    import BinaryStatusNoticeView from "./Parts/BinaryStatusNoticeView.svelte";
    import {SizeUtil} from "../../../../lib/Common/Value/SizeUtil";
    import BinaryIconView from "./Parts/BinaryIconView.svelte";
    import {QrCodeDialogStore} from "../../../../store/dialog/QrCodeDialogStore";
    import BinaryDeleteProtectView from "./Parts/BinaryDeleteProtectView.svelte";
    import SpaceLoadView from "../../../../component/Space/SpaceLoadView.svelte";
    import ValueSlotView from "../../../../component/common/Value/ValueSlotView.svelte";
    import PortalView from "../../../../component/common/Portal/PortalView.svelte";

    export let params;

    $: pageTitle = (() => {
        if (space == null) {
            return 'バイナリ';
        }
        const pageTitleArray = [];
        pageTitleArray.unshift(space.name);

        if (app == null) {
            return pageTitleArray.join(' - ');
        }
        pageTitleArray.unshift(app.name);
        if (binary == null) {
            return pageTitleArray.join(' - ');
        }
        pageTitleArray.unshift(binary.name);

        return pageTitleArray.join(' - ');
    })();

    $: app = (() => {
        if (binary == null) {
            return null;
        }
        const app = binary.app;
        return app;
    })();


    $: thumbnailUrl = (() => {
        if (binary == null) {
            return null;
        }

        const thumbnailUrl = BinaryUtil.createThumbnailUrl(binary);
        return thumbnailUrl;
    })();

    $: appLink = (() => {
        return `/#/space/${params['space_unique_id']}/app/${params['app_unique_id']}`;
    })();

    $: {
        if (space != null) {
            loadData(params);
        }
    }

    let space = null;
    let binary = null;
    let isLoading = false;

    let editData = null;
    let addTagBinary = null;

    let qrCodeImageTitle = null;
    let qrCodeImageUrl = null;

    onMount(() => {
    });

    function onLoadSpace(event) {
        space = event.detail.space;
    }


    function loadData(params) {
        const paramMap = {};
        paramMap['space_id'] = space.id;
        const uniqueId = params['binary_unique_id'];
        paramMap['unique_id'] = uniqueId;

        paramMap['include_app'] = undefined;
        paramMap['include_binary_tags'] = undefined;
        paramMap['include_binary_tags_tag'] = undefined;
        paramMap['with_download_key'] = undefined;

        const url = UrlUtil.createApiUrl("binary", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            const binaries = body['binaries'];
            if (binaries.length > 0) {
                binary = binaries[0];
            } else {
                binary = null;
            }


        });
    }

    function onClickEdit() {
        editData = {...binary};
    }

    function onOpenAddBinaryTag(event) {
        const binary = event.detail.binary;
        addTagBinary = binary;
    }

    function onUpdate() {
        loadData(params);
    }


    function onClickVersionQrCode() {
        const version = binary.version;
        const showData = new QrCodeDialogStore.ShowData();
        showData.qrCodeValue = version;
        showData.title = `バージョン: ${version} のコピペ用`;
        showData.size = 300;
        QrCodeDialogStore.showData.set(showData);

    }

</script>

<HtmlTitleView pageTitle={pageTitle}/>

<div class="binary-page standard-page">
    <SpaceLoadView spaceUniqueId={params['space_unique_id']}
                   on:load={onLoadSpace}
                   isShowNotFoundMessage={true}
    >
        <LoadingContentView isLoading={isLoading}>
            <ValueSlotView value={app}>
                <div class="binary-content">
                    <PortalView portalTargetSelector="#header-page-portal-target">
                        <div>

                            <a href={appLink}>
                                { app.name }
                            </a>

                            <FontAwesomeView icon="chevron-right"/>

                            { binary.name }

                        </div>
                    </PortalView>


                    <div>
                        <BackLinkView url={appLink}/>
                    </div>

                    <div class="binary-area">
                        <div class="status-notice-area">
                            <BinaryStatusNoticeView binary={binary}/>
                        </div>

                        <div class="head-area">
                            <div class="icon-name-area">
                                <div class="icon-name">
                                    <div class="icon">
                                        <BinaryIconView binary={binary}/>
                                    </div>
                                    <div class="name-area">
                                        <div class="app-name">
                                            <a href={appLink}>
                                                { app.name }
                                            </a>
                                        </div>
                                        <div class="binary-name">

                                            <PlatformTypeIconView platformType={binary.platform_type}/>

                                            { binary.name }

                                            <div class="edit-button">
                                                <EditButtonView on:click={onClickEdit}/>
                                            </div>

                                            <div class="delete-protect-area">
                                                <BinaryDeleteProtectView binary={binary} on:update/>
                                            </div>

                                            <div class="copy-button">
                                                <BinaryLinkCopyButtonView
                                                        spaceUniqueId={space.unique_id}
                                                        appUniqueId={app.unique_id} binary={binary}
                                                />
                                            </div>


                                        </div>


                                    </div>

                                    <div class="ci-job-link-area">
                                        <BinaryCiJobLinkView binary={binary}/>
                                    </div>

                                    <div class="download-area">
                                        <fieldset>
                                            <legend>ファイルとしてダウンロード</legend>
                                            <BinaryDownloadView binary={binary}/>
                                        </fieldset>

                                    </div>
                                </div>

                                <div class="information-area">
                                    <div>
                                        <BinaryStatusAreaView binary={binary}/>
                                    </div>

                                    <div>
                                        <LabelValueView label="ユニークID" value={binary.unique_id}/>
                                        <LabelValueView label="version" value={binary.version}/>
                                        {#if binary.version != null}
                                        <span class="version-qr-code-button" on:click={onClickVersionQrCode}>
                                            <FontAwesomeView icon="qrcode"/>
                                        </span>
                                        {/if}
                                        <LabelValueView label="m5 hash" value={binary.md5_hash}/>
                                        <LabelValueView label="ファイルサイズ"
                                                        value={SizeUtil.formatBytes(binary.file_size) }/>
                                        <LabelValueView label="ファイル名" value={binary.file_name}/>
                                        <LabelValueView label="DL回数" value={binary.download_count}/>
                                        <LabelValueView label="最終DL日時" value={binary.latest_download_at}/>
                                        <LabelValueView label="内部ID" value={binary.id}/>
                                    </div>


                                </div>
                                <div class="tag-area">
                                    <BinaryTagAreaView spaceUniqueId={space.unique_id} appUniqueId={app.unique_id}
                                                       binary={binary}
                                                       canEdit={true}
                                                       canJumpUrl={true}
                                                       on:openAddBinaryTag={onOpenAddBinaryTag} on:update={onUpdate}
                                    />
                                </div>
                                <div class="created-updated-area">
                                    <CreatedUpdatedView model={binary} isHorizontal={true} isShowUser={false}/>
                                </div>

                            </div>


                            <div class="qr-code-area">
                                <fieldset>
                                    <legend>インストールQRコード</legend>
                                    <BinaryQrCodeView binary={binary} on:update={onUpdate}
                                                      isLargeQrCode={true}/>
                                </fieldset>

                            </div>

                        </div>


                        <div class="description-area">
                            <BinaryDescriptionView binary={binary}/>
                        </div>
                    </div>
                </div>

            </ValueSlotView>

        </LoadingContentView>


    </SpaceLoadView>


</div>

<BinaryEditDialogView
        space={space}
        app={app}
        editData={editData}
        on:update={onUpdate}
        on:close={()=>{
            editData = null;
        }}
        on:delete={()=>{
            location.assign(appLink);
        }}
/>

<BinaryTagAddDialogView
        binary={addTagBinary}
        on:update={onUpdate}
        on:close={()=>{
            addTagBinary = null;
        }}
/>


<style lang="scss">
    .binary-page {
        .binary-content {
            display: flex;
            flex-direction: column;
            gap: 16px;

            .binary-area {
                .head-area {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;

                    .icon-name-area {

                        flex-grow: 1;

                        .icon-name {
                            display: flex;
                            align-items: center;
                            gap: 12px;


                            .icon {
                                height: 100px;
                                width: 100px;
                            }

                            .name-area {
                                flex-grow: 1;

                                .app-name {

                                }

                                .binary-name {
                                    font-size: 1.5em;
                                    display: flex;
                                    align-items: center;
                                    gap: 8px;

                                    .edit-button {
                                        font-size: 0.75em;
                                    }

                                    .copy-button {
                                        margin-left: 32px;

                                    }
                                }
                            }

                        }

                    }

                    .ci-job-link-area {
                        font-size: 0.9em;

                    }

                    .download-area {
                    }

                    .qr-code-area {

                    }
                }

                .information-area {
                    .version-qr-code-button {
                        cursor: pointer;
                    }

                }

                .tag-area {
                    margin-top: 12px;

                    font-size: 0.9em;
                }

                .created-updated-area {
                    opacity: 0.75;
                    font-size: 0.75em;

                }

                .description-area {
                    margin-top: 12px;

                }
            }
        }

    }
</style>